import React from 'react';
import { motion } from 'framer-motion';
import ResultsHeader from './ResultsHeader/ResultsHeader';
import ResultsTable from './ResultsTable/ResultsTable';
import ResultsPagination from './ResultsPagination/ResultsPagination';
import { Result } from '../../../../services/serpApi'; // Importando a interface centralizada
import { SearchControls } from '../SearchSection/SearchSection'; // Importando SearchControls

interface ResultsSectionProps {
  results: Result[]; // Paginated view
  filteredChunkResults: Result[]; // Novo: Chunk completo filtrado
  selectedResults: number[];
  setSelectedResults: (ids: number[]) => void;
  onDeleteResults: (ids: number[]) => void;
  onDeleteResult: (id: number) => void; // Nova prop para exclusão individual
  onSaveSelectedResults: () => Promise<void>; // Nova prop
  onVerifySelectedNumbers: () => Promise<void>; // Nova prop
  isVerifying: boolean; // Novo estado de carregamento
  isWhatsappConnected: boolean; // Novo: Estado de conexão do WhatsApp
  
  // Props de Paginação
  currentPage: number;
  totalResults: number; // Total de resultados no CHUNK (bruto)
  resultsPerPage: number;
  onPageChange: (page: number) => void;
  hasMoreChunks: boolean;
  
  // NEW: Props para controle de filtros
  currentControls: SearchControls;
  onUpdateControls: (newControls: SearchControls) => void;
}

const ResultsSection: React.FC<ResultsSectionProps> = ({
  results,
  filteredChunkResults, // Usando o novo prop
  selectedResults,
  setSelectedResults,
  onDeleteResults,
  onDeleteResult, // Recebendo a prop
  onSaveSelectedResults,
  onVerifySelectedNumbers, // Recebendo a prop
  isVerifying, // Recebendo o estado
  isWhatsappConnected, // Recebendo o estado de conexão
  currentPage,
  totalResults,
  resultsPerPage,
  onPageChange,
  hasMoreChunks,
  currentControls,
  onUpdateControls,
}) => {
  // O total de resultados para a paginação agora é o tamanho do chunk FILTRADO
  const totalResultsForPagination = filteredChunkResults.length;
  
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5, duration: 0.5 }}
      className="flex flex-col gap-4 rounded-xl p-4 bg-white dark:bg-gray-800/30 border border-gray-200 dark:border-gray-700/50 card"
    >
      <ResultsHeader 
        totalResults={totalResults} // Total geral da API
        selectedResults={selectedResults}
        setSelectedResults={setSelectedResults}
        allResults={filteredChunkResults} // Passando o chunk filtrado
        onDeleteResults={onDeleteResults}
        onSaveSelectedResults={onSaveSelectedResults} 
        onVerifySelectedNumbers={onVerifySelectedNumbers} // Passando o handler
        isVerifying={isVerifying} // Passando o estado
        isWhatsappConnected={isWhatsappConnected} // Passando o estado de conexão
        
        // Passando props de Paginação para o Header
        currentPage={currentPage}
        resultsPerPage={resultsPerPage}
        onPageChange={onPageChange}
        hasMoreChunks={hasMoreChunks}
        
        // NEW: Passando props de controle
        currentControls={currentControls}
        onUpdateControls={onUpdateControls}
      />
      <ResultsTable 
        results={results} // Resultados paginados
        selectedResults={selectedResults}
        setSelectedResults={setSelectedResults}
        onDeleteResult={onDeleteResult} // Passando o handler
      />
      <ResultsPagination 
        currentPage={currentPage}
        totalResults={totalResultsForPagination} // Total de resultados no chunk FILTRADO
        resultsPerPage={resultsPerPage}
        onPageChange={onPageChange}
        hasMoreChunks={hasMoreChunks}
      />
    </motion.div>
  );
};

export default ResultsSection;